<template>
    <div id="PaymentHistory" style="min-height: inherit; display: flex; flex-direction: column;">
        <Header title="History"/>
            <div class="mainbody">
                <div id="content">
                    <ErrorList v-if="error" :error="error"/>
                    <template v-if="hasInvoices()">
                         <b-table :items="invoices" :fields="fields" striped responsive="sm" class="nested-table" table-class="HistoryTable" details-td-class="ReportDetailRow">
                             <template v-slot:cell(payrollPeriod)="data">
                                 {{ payrollPeriod(data.item) }}
                             </template>

                             <template v-slot:cell(reportCommands)="row">
                                <b-button v-if="hasPayroll(row.item.payrollReport)" size="sm" @click="row.toggleDetails()" class="ReportDetailToggle">
                                    {{ row.item._showDetails ? '&#9652;' : '&#9662;' }}
                                </b-button>
                            </template>

                             <template #head(reportCommands)>
                                 <a href="#" @click="expandAll" title="Click to expand all">Details</a>
                             </template>

                            <template v-slot:row-details="row">
                                <b-card class="nested-card" v-if="hasPayroll(row.item.payrollReport)">
                                    <b-table-simple table-class="ReportDetailTable">
                                        <b-thead>
                                            <b-th>State</b-th>
                                            <b-th>Class</b-th>
                                            <b-th>Description</b-th>
                                            <b-th>Payroll</b-th>
                                            <b-th>Premium</b-th>
                                        </b-thead>
                                        <b-tbody>
                                            <b-tr v-for="(line, i) in row.item.payrollReport.lines" :key="i">
                                                <b-td>{{ line.classCode.location.state }}</b-td>
                                                <b-td>{{ line.classCode.classCode }}</b-td>
                                                <b-td>{{ line.classCode.description }}</b-td>
                                                <b-td>{{ line.payroll | currency }}</b-td>
                                                <b-td>{{ line.premium | currency }}</b-td>
                                            </b-tr>
                                        </b-tbody>
                                        <b-tfoot>
                                            <b-tr>
                                                <b-td colspan="3"></b-td>
                                                <b-td>{{ row.item.payrollReport.payrollTotal | currency }}</b-td>
                                                <b-td>{{ row.item.payrollReport.premiumTotal | currency }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td colspan="3"></b-td>
                                                <b-th>Taxes:</b-th>
                                                <b-td>{{ row.item.payrollReport.taxTotal | currency }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td colspan="3"></b-td>
                                                <b-th>Total:</b-th>
                                                <b-td>{{ row.item.payrollReport.reportTotal | currency }}</b-td>
                                            </b-tr>
                                        </b-tfoot>
                                    </b-table-simple>
                                </b-card>
                            </template>
                        </b-table>

                        <p style="text-align: center;">Returns are subject to a $25 service fee.</p>
                    </template>
                    <p v-else>History is unavailable for the current insured's policies.</p>
                </div>
                <CompanyInfo/>
            </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from './shared/Header'
import CompanyInfo from './shared/CompanyInfo'
import ErrorList from './shared/ErrorList'
import moment from 'moment'
import { create } from '@/utils/helpers'

export default {
    name: 'PaymentHistory',
    components: { CompanyInfo, Header, ErrorList },
    data() {
        return {
            error: null,
            fields: [
                {key: 'policyName', label: 'Policy Number', thClass: 'PolicyNumber', tdClass: 'PolicyNumber'},
                //{key: 'invoice.recordNo',       label: 'Invoice Id'}, //TODO Put back in only for Account Managers (and DEV)
                {key: 'invoice.name', label: 'Invoice Number'},
                {key: 'payrollPeriod', label: 'Payroll Period'},
                {key: 'invoice', label: 'Status', formatter: 'invoiceStatus'},
                {key: 'invoice.invoiceTotal', label: 'Invoice Total', formatter: 'formatCurrency'},
                {key: 'invoice.balanceDue', label: 'Balance Due', formatter: 'formatCurrency'},
                // {key: 'invoice', label: 'Date Submitted', formatter: 'formatSubmitDate'},
                {key: 'reportCommands', label: 'Details', thClass: 'Details', tdClass: 'Details'}
                ]
        }
    },
    mounted() {
        this.loadHistory()
    },
    methods: {
        loadHistory() {
            if (this.loadedHistory === false) {
                let promises = [
                    this.$store.dispatch('setOverlayMessage', 'Loading history'),
                    this.$store.dispatch('fetchInvoices')
                ]
                Promise.all(promises).catch((error) => {
                    this.error = error
                    event.target.focus()
                })
            }
        },
        hasInvoices() {
            return this.invoices.length > 0
        },
        hasPolicies() {
            return this.policies.length > 0
        },
        hasPayroll(payrollReport){
            return payrollReport && payrollReport.lines.length > 0
        },
        formatInvoiceDate(invoiceDate) {
            return moment(invoiceDate).format('MM/DD/YYYY')
        },
        formatInvoiceDateShort(invoiceDate) {
            return moment(invoiceDate).format('MM/DD')
        },
        // formatSubmitDate(submitDate) {
        //     return submitDate && moment(submitDate).format('MM/DD/YYYY hh:mm:ss a')
        // },
        formatCurrency(balance){
            return this.$options.filters.currency(balance)
        },
        invoiceStatus(invoice){
            return (invoice && invoice.status) || 'Not yet invoiced'
        },
        payrollPeriod(item) {
            if (item.payrollReport){
                if (item.payrollReport.reportingPeriodStartDate.year === item.payrollReport.reportingPeriodEndDate.year) {
                    return this.formatInvoiceDateShort(item.payrollReport.reportingPeriodStartDate) + ' - ' + this.formatInvoiceDate(item.payrollReport.reportingPeriodEndDate)

                } else {
                    return this.formatInvoiceDate(item.payrollReport.reportingPeriodStartDate) + ' - ' + this.formatInvoiceDate(item.payrollReport.reportingPeriodEndDate)
                }

            } else if (item.invoice) {
                return item.invoice.invoiceType + ' ' + this.formatInvoiceDate(item.displayDate);
            }
        },
        expandAll() {
            for(const item of this.invoices) {
                this.$set(item, '_showDetails', true)
            }
        }
    },
    computed: {
        ...mapState([ 'invoices', 'policies', 'loadedHistory' ])
    },
    created() {
        create(this)
    }
}
</script>

<style scoped>
    .nested-card{
        margin: 0;
    }
    .nested-table table{
        font-size: 1em;
    }
    .nested-table th {
        background-color: #9ac8c9;
        color: black;
        font-weight: bold;
        padding: 6px 8px;
    }
    .nested-table td {
        padding: 6px 8px;
    }
    .nested-table tbody tr:nth-child(odd) {
        background-color: #ffffff;
    }
    .nested-table tbody tr:nth-child(even) {
        background-color: #f1f1f1;
    }
    .nested-table tbody tr {
        border-left: none;
        border-right: none;
    }
    .nested-table tbody tr:last-child {
        border-bottom: none;
    }
    .nested-table tfoot td {
        background-color: #9ac8c9;
    }
</style>
